import React from 'react';
import equantiaLogo from '../img/logo.png';

const Logo = props => {
  return <img src={equantiaLogo} alt='Equantia Logo' width={props.width} />;
};

export default Logo;
